import React from "react";
import { Container, Paper, Typography, Box, List, ListItem } from "@mui/material";

export default function PrivacyEasyFinances() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={4} sx={{ borderRadius: 4, p: { xs: 3, md: 6 } }}>
        
        <Typography variant="h3" fontWeight="bold" color="primary" mb={3}>
          Política de Privacidad – EasyFinances
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={5}>
          Última actualización: 19 de noviembre de 2025 <br />
          Desarrollador: Devssoft (Jacob Sánchez Bejarano)
        </Typography>

        {/* 1. Información */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            1. Información que recopilamos
          </Typography>

          <Typography mb={2}>
            EasyFinances <strong>NO recopila información personal identificable</strong>, 
            como nombre, correo, teléfono o datos de contacto.
          </Typography>

          <Typography mb={2}>
            Sólo procesamos los datos necesarios para el funcionamiento interno de la app:
          </Typography>

          <Typography variant="subtitle1" fontWeight="bold" mt={2}>
            1.1 Datos ingresados por el usuario
          </Typography>

          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <ListItem sx={{ display: "list-item" }}>Ingresos y gastos</ListItem>
            <ListItem sx={{ display: "list-item" }}>Categorías contables</ListItem>
            <ListItem sx={{ display: "list-item" }}>Descripciones de movimientos</ListItem>
            <ListItem sx={{ display: "list-item" }}>Presupuestos</ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Registros de partida doble (Debe/Haber)
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>Fechas asociadas</ListItem>
          </List>

          <Typography mt={2}>
            <strong>Toda esta información se almacena únicamente en tu dispositivo.</strong>
          </Typography>

          <Typography variant="subtitle1" fontWeight="bold" mt={3}>
            1.2 Datos técnicos no personales
          </Typography>

          <Typography>
            Podemos recopilar datos técnicos no identificables como versión de la app, 
            modelo de dispositivo o registros de errores.
          </Typography>
        </Box>

        {/* 2. Permisos */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            2. Permisos utilizados
          </Typography>

          <Typography>EasyFinances utiliza únicamente los permisos mínimos necesarios:</Typography>

          <List sx={{ listStyleType: "disc", pl: 4, mt: 1 }}>
            <ListItem sx={{ display: "list-item" }}>Almacenamiento local (AsyncStorage)</ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Acceso a red (sólo para actualizaciones internas de Play Store)
            </ListItem>
          </List>

          <Typography mt={2}>
            La app <strong>NO accede</strong> a contactos, cámara, galería, ubicación, 
            micrófono ni archivos personales.
          </Typography>
        </Box>

        {/* 3. Uso */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            3. Cómo utilizamos tu información
          </Typography>

          <Typography>
            La información se usa exclusivamente para registrar movimientos financieros,
            generar resúmenes, calcular totales y mejorar la experiencia dentro de la app.
          </Typography>

          <Typography mt={2} fontWeight="bold">
            EasyFinances no comparte, vende ni transfiere tus datos.
          </Typography>
        </Box>

        {/* 4. Protección */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            4. Protección de datos
          </Typography>

          <Typography>Aplicamos medidas para proteger la información local:</Typography>

          <List sx={{ listStyleType: "disc", pl: 4, mt: 1 }}>
            <ListItem sx={{ display: "list-item" }}>Sin servidores externos</ListItem>
            <ListItem sx={{ display: "list-item" }}>Sin servicios de nube</ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Los datos sólo viven en tu dispositivo
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Sin trackings ni SDKs de publicidad
            </ListItem>
          </List>
        </Box>

        {/* 5. Retención */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            5. Retención y eliminación
          </Typography>

          <Typography>
            Los datos permanecen en tu dispositivo hasta que desinstales la app o utilices
            alguna función de borrado interno. Al desinstalar, 
            <strong> toda la información se elimina.</strong>
          </Typography>
        </Box>

        {/* 6. Menores */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            6. Privacidad de menores
          </Typography>

          <Typography>
            EasyFinances no está diseñada para menores de 13 años y no recopila información
            de menores intencionalmente.
          </Typography>
        </Box>

        {/* 7. Terceros */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            7. Servicios de terceros
          </Typography>

          <Typography>
            EasyFinances <strong>no utiliza</strong> servicios de terceros para almacenamiento,
            publicidad, analítica ni tracking.
          </Typography>
        </Box>

        {/* 8. Cambios */}
        <Box mb={6}>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            8. Cambios a esta política
          </Typography>

          <Typography>
            Podemos actualizar esta Política de Privacidad cuando sea necesario.
            La fecha al inicio del documento reflejará la última modificación.
          </Typography>
        </Box>

        {/* 9. Contacto */}
        <Box>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            9. Contacto
          </Typography>

          <Typography>Si tienes dudas o preguntas, puedes comunicarte con el desarrollador:</Typography>

          <Box
            mt={3}
            p={3}
            sx={{
              backgroundColor: "grey.100",
              borderRadius: 2,
            }}
          >
            <Typography fontWeight="bold">Devssoft – Desarrollo de Software</Typography>
            <Typography>Correo: jake_76847@hotmail.com</Typography>
            <Typography>Sitio web: https://devssoft.com</Typography>
          </Box>
        </Box>

      </Paper>
    </Container>
  );
}
